import {Controller} from "@hotwired/stimulus"
import {basicSetup, EditorView} from "codemirror"
import {sql} from "@codemirror/lang-sql"
import {EditorState} from "@codemirror/state"

export default class extends Controller {

  static targets = [ "input", "container" ]
  static values = {
    mode: String
  }
  connect() {
    this.initializeCodeMirror();
  }

  initializeCodeMirror() {
    const controller = this
    

    const startState = EditorState.create({
      doc: this.inputTarget.value,
      extensions: [
          basicSetup, sql(),
          EditorView.updateListener.of(function(e) {
            if (e.docChanged) {
              controller.inputTarget.value = e.state.doc.toString()
            }
          })
      ],
    })

    this.codeMirrorInstance = new EditorView({
      parent: this.containerTarget,
      state: startState,
    })
  }
}